import React from 'react';
import { toast } from 'react-toastify';
import UpdateIcon from '@mui/icons-material/Update';
import Timer from './Countdown/Timer';
import SmoothLinearProgress from './ProgressBar/SmoothLinearProgress';

// Requires to render ToastContainer in the component showRefreshNotificaiton is being used
const showRefreshNotification = (seconds) => {
    const countdown = <div className='refresh-root'>
            <Timer refreshFrequency={seconds} />
            <SmoothLinearProgress refreshFrequency={seconds} />
        </div>;

    return toast(countdown, { icon: <UpdateIcon fontSize='large' />, autoClose: seconds * 1000, pauseOnHover: false, pauseOnFocusLoss: false, hideProgressBar: true });
}

export default showRefreshNotification;
